<template>
	<div>
		<div class="container">
			<div class="project-desc">
				<div class="row">
					<div class="col-md-auto pr-md-0">
						<img
							:src="project.logo"
							:alt="project.name"
							class="project-desc__logo"
						/>
					</div>
					<div class="col">
						<div class="row align-items-center">
							<div class="col-xl">
								<h1>{{ project.name }}</h1>
							</div>
							<div class="col-xl-auto">
								<div class="project-mockups d-md-none">
									<div class="container">
										<div class="mockup-desktop">
											<img
												:src="project.desktopImg"
												:alt="project.name"
											/>
										</div>
									</div>
								</div>
								<div class="project-desc__links d-none d-md-flex">
									<div
										class="site-link"
										v-if="project.site"
									>
										<a
											:href="project.site"
											target="_blank"
											>{{ $t('projectsPage.site') }}:
											<i class="icon-web-site"></i
										></a>
									</div>
									<div
										class="divider"
										v-if="
											project.site &&
											(project.googleplay || project.appstore)
										"
									></div>
									<div
										class="mobile-apps"
										v-if="project.googleplay || project.appstore"
									>
										<a
											v-if="project.googleplay"
											:href="project.googleplay"
											target="_blank"
											><i class="icon-googleplay-download"></i
										></a>
										<a
											v-if="project.appstore"
											:href="project.appstore"
											target="_blank"
											><i class="icon-appstore-download"></i
										></a>
									</div>
								</div>
								<div class="actions-list d-md-none">
									<a
										v-if="project.site"
										class="actions-list__btn"
										:href="project.site"
										target="_blank"
									>
										<i class="icon-web-site"></i>
										<span>{{
											project.domen || $t('projectsPage.site')
										}}</span>
									</a>
									<a
										v-if="project.appstore"
										class="actions-list__btn"
										:href="project.appstore"
										target="_blank"
									>
										<i class="icon-appstore"></i>
										<span>{{ $t('projectsPage.iosApp') }}</span>
									</a>
									<a
										v-if="project.googleplay"
										class="actions-list__btn"
										:href="project.googleplay"
										target="_blank"
									>
										<i class="icon-googleplay"></i>
										<span>{{ $t('projectsPage.androidApp') }}</span>
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div
					class="project-desc__tags d-none d-md-flex"
					v-if="project.tags && project.tags.length"
				>
					<span
						class="tag"
						v-for="(tag, i) in project.tags"
						:key="i"
						>{{ '#' + tag }}</span
					>
				</div>
				<div
					class="project-desc__content content"
					v-if="project.content"
					v-html="project.content"
				></div>
			</div>
		</div>

		<div class="project-mockups d-none d-md-block">
			<div class="container">
				<div class="mockup-desktop">
					<img
						:src="project.desktopImg"
						:alt="project.name"
					/>
				</div>
				<div class="mockup-iphone">
					<img
						:src="project.iphoneImg"
						:alt="project.name"
					/>
				</div>
				<div class="mockup-android">
					<img
						:src="project.androidImg"
						:alt="project.name"
					/>
				</div>
			</div>
		</div>

		<div class="container">
			<div class="mockup-iphone_mobile d-md-none">
				<img
					:src="project.iphoneImg"
					:alt="project.name"
				/>
				<a
					v-if="project.appstore"
					class="download-app-btn"
					:href="project.appstore"
					target="_blank"
				>
					<i class="icon-appstore-download"></i>
				</a>
			</div>

			<div class="mockup-android_mobile d-md-none">
				<img
					:src="project.androidImg"
					:alt="project.name"
				/>
				<a
					v-if="project.googleplay"
					class="download-app-btn"
					:href="project.googleplay"
					target="_blank"
				>
					<i class="icon-googleplay-download"></i>
				</a>
			</div>

			<div
				class="project-about-list"
				v-if="project.aboutList && project.aboutList.length"
			>
				<div
					class="project-about-list__item"
					v-for="(item, i) in project.aboutList"
					:key="i"
				>
					<div class="item-text">
						<div class="title">{{ item.title }}</div>
						<div
							class="text"
							v-if="item.text"
							v-html="item.text"
						></div>
					</div>
					<div
						class="item-img"
						v-if="item.icon"
					>
						<img
							:src="item.icon"
							:alt="item.title"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['slug'],

	computed: {
		project() {
			let project = this.$store.getters['projects/projectBySlug'](this.slug)
			if (project === false) return $router.push({ name: 'Projects' })
			else return project
		},
	},
}
</script>

<style lang="scss" scoped>
@import '@/sass/_variables';

.project-desc {
	margin-top: 80px;
	h1,
	.h1 {
		margin: 0 0 16px;
	}
	&__logo {
		user-select: none;
		display: block;
		max-width: 100%;
		width: 102px;
	}
	&__links {
		display: flex;
		align-items: center;
		user-select: none;
		.site-link a {
			color: #ffffff;
			display: inline-flex;
			align-items: center;
			text-decoration: none;
			transition: 0.3s;
			i {
				margin-left: 10px;
				font-size: 20px;
			}
			&:hover {
				color: lighten($primary, 5%);
				text-shadow: 0 0 15px rgba(#fff, 0.1);
			}
		}
		.mobile-apps {
			display: flex;
			a {
				font-size: 140px;
				height: 42px;
				display: flex;
				align-items: center;
				color: #ffffff;
				transition: 0.3s;
				overflow: hidden;
				text-decoration: none;
				&:hover {
					color: lighten($primary, 5%);
					text-shadow: 0 0 15px rgba(#fff, 0.1);
				}
				&:not(:last-child) {
					margin-right: 16px;
				}
			}
		}
		.divider {
			width: 1px;
			height: 24px;
			background: #30393e;
			margin: 0 16px;
		}
	}
	&__tags {
		display: flex;
		flex-wrap: wrap;
		margin: 32px -12px -16px;
		.tag {
			margin: 4px 12px;
			font-weight: 500;
			font-size: 15px;
		}
	}
}
@media (max-width: $xl) {
	.project-desc {
		margin-top: 60px;
		&__links {
			margin: 8px 0 0;
		}
	}
}
@media (max-width: $lg) {
	.project-desc {
		margin-top: 24px;
		&__logo {
			width: 80px;
		}
	}
}
@media (max-width: $md) {
	.project-desc {
		h1,
		.h1 {
			text-align: center;
		}
		&__logo {
			margin: 0 auto 32px;
		}
		&__content {
			margin-top: 16px;
		}
	}
}

.project-mockups {
	margin: 48px 0 78px;
	width: 100%;
	height: 684px;
	overflow: hidden;
	position: relative;
	&::before {
		content: '';
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		background-image: url('../assets/project__ellipse-1.svg');
		background-repeat: no-repeat;
		background-position: center bottom;
	}
	&::after {
		content: '';
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 296px;
		background: linear-gradient(
			180deg,
			rgba(102, 0, 204, 0) 0%,
			#02218a 100%
		);
		opacity: 0.2;
	}
	.container {
		position: relative;
		height: 100%;
	}
	img {
		display: block;
		max-width: 100%;
		position: absolute;
		user-select: none;
		pointer-events: none;
	}
	.mockup-desktop img {
		width: 1006px;
		right: 18px;
		bottom: -12px;
		z-index: 1;
	}
	.mockup-iphone img {
		width: 206px;
		left: 18px;
		bottom: -48px;
		z-index: 3;
	}
	.mockup-android img {
		width: 166px;
		left: 192px;
		bottom: -64px;
		z-index: 2;
	}
}
.mockup-iphone_mobile,
.mockup-android_mobile {
	padding: 30px 0 10px;
	position: relative;
	overflow: visible;
	img {
		display: block;
		max-width: 100%;
		margin: 0 auto;
		position: relative;
		z-index: 2;
		user-select: none;
		pointer-events: none;
	}
	.download-app-btn {
		position: absolute;
		bottom: 5px;
		left: calc(50% - 68px);
		z-index: 3;
		font-size: 136px;
		width: 135px;
		height: 37px;
		display: flex;
		align-items: center;
		overflow: hidden;
		border-radius: 14px;
		color: #ffffff;
		transition: 0.3s;
		&:hover {
			color: lighten($primary, 10%);
		}
	}
	&::before {
		content: '';
		position: absolute;
		width: 454px;
		height: 748px;
		max-height: 100%;
		background-image: url('../assets/project__ellipse-2.svg');
		background-repeat: no-repeat;
		background-size: contain;
		background-position: center;
	}
}
.mockup-iphone_mobile {
	.download-app-btn {
		position: absolute;
		bottom: -10px;
		background-color: #000;
	}
	&::before {
		top: 10px;
		left: calc(50% - 229px - 10px);
	}
}
.mockup-android_mobile {
	&::before {
		top: 5px;
		left: calc(50% - 229px);
		transform: rotate(55deg) scale(0.9);
	}
}
@media (max-width: $xl) {
	.project-mockups {
		margin-top: 36px;
		height: 586px;
		&::before {
			top: 80px;
		}
		.mockup-desktop img {
			width: 864px;
		}
		.mockup-iphone img {
			width: 176px;
		}
		.mockup-android img {
			width: 140px;
			left: 168px;
		}
	}
}
@media (max-width: $lg) {
	.project-mockups {
		margin: 24px 0 48px;
		height: 420px;
		&::before {
			top: 170px;
		}
		.mockup-desktop img {
			width: 610px;
			bottom: -6px;
		}
		.mockup-iphone img {
			width: 126px;
			bottom: -28px;
		}
		.mockup-android img {
			width: 100px;
			left: 128px;
			bottom: -38px;
		}
	}
}
@media (max-width: $md) {
	.project-mockups {
		margin: 0 0 8px calc(-50vw + 50%);
		width: 100vw;
		height: auto;
		padding: 36px 0 0;
		&::before {
			top: 20px;
			background-size: 296%;
			background-position: 64% 0;
		}
		&::after {
			height: 42px;
		}
		.mockup-desktop img {
			position: relative;
			width: 100%;
			left: 0;
			bottom: 0;
		}
	}
}

.project-about-list {
	&__item {
		background: #1d262b;
		border-radius: 25px;
		padding: 48px;
		display: flex;
		&:not(:last-child) {
			margin-bottom: 24px;
		}
		.item-text {
			flex: 1 0;
			.title {
				color: #ffffff;
				font-weight: bold;
				font-size: 36px;
			}
			.text {
				margin-top: 24px;
				font-size: 15px;
				color: #aaaaaa;
			}
		}
		.item-img {
			width: 256px;
			max-width: 100%;
			margin-left: 36px;
			img {
				display: block;
				max-width: 100%;
				user-select: none;
				pointer-events: none;
				margin: 0 auto;
			}
		}
	}
}
@media (max-width: $lg) {
	.project-about-list {
		&__item {
			.item-text {
				.title {
					font-size: 22px;
				}
				.text {
					margin-top: 16px;
					font-size: 14px;
				}
			}
			.item-img {
				margin-left: 24px;
			}
		}
	}
}
@media (max-width: $md) {
	.project-about-list {
		margin-top: 24px;
		&__item {
			flex-direction: column;
			align-items: center;
			padding: 36px;
			text-align: center;
			&:not(:last-child) {
				margin-bottom: 16px;
			}
			.item-text {
				order: 2;
				.title {
					font-size: 16px;
				}
				.text {
					font-size: 13px;
				}
			}
			.item-img {
				order: 1;
				margin: 0 0 24px;
			}
		}
	}
}
</style>

<style lang="scss">
@import '@/sass/_variables';

.project-desc__content {
	margin-top: 36px;
	ul {
		color: #f2f2f2;
	}
}
@media (max-width: $md) {
	.project-desc__content {
		a:not(:hover) {
			color: lighten($primary, 10%);
		}
		b {
			display: inline-block;
			font-weight: 500;
			font-size: 15px;
			margin-bottom: 4px;
		}
		ul {
			margin-left: 0;
		}
	}
}
</style>
